import React from 'react'
import styled from 'styled-components'
import { scoreBand, scoreColour } from './scoreColour'
import { radius, font } from 'features/dashboard/tokens'

const StatusPill = ({ score, children }) => {
  const colour = scoreColour(score)
  return (
    <Pill $colour={colour}>
      <Dot $colour={colour} />
      {children || scoreBand(score)}
    </Pill>
  )
}

export default StatusPill

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: ${radius.pill};
  font-size: ${font.caption};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: ${({ $colour }) => `${$colour}1A`};
  color: ${({ $colour }) => $colour};
`

const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: ${radius.round};
  background: ${({ $colour }) => $colour};
`
